import { render, staticRenderFns } from "./TabExame.vue?vue&type=template&id=83aa233a&scoped=true&"
import script from "./TabExame.vue?vue&type=script&lang=js&"
export * from "./TabExame.vue?vue&type=script&lang=js&"
import style0 from "./TabExame.vue?vue&type=style&index=0&id=83aa233a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aa233a",
  null
  
)

export default component.exports